import React, { useEffect } from 'react';

function withStickyNavbar(WrappedComponent) {
    return function StickyNavbarWrapper(props) {
        useEffect(() => {
            function handleScroll() {
                var navbar = document.getElementById('navbar');
                var content = document.querySelector('.content');
                var navbarOffsetTop = content.offsetTop;

                if (window.pageYOffset > navbarOffsetTop) {
                    navbar?.classList?.add('sticky-navbar');
                } else {
                    navbar?.classList?.remove('sticky-navbar');
                }
            }

            window.addEventListener('scroll', handleScroll);

            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        }, []);

        return <WrappedComponent {...props} />;
    };
}

export default withStickyNavbar;
